import { ReactNode, useCallback, useMemo } from 'react';

import { GtmPayload } from '@gn-audio/jss-core/common/models';

import { TrackingContext } from '../contexts';

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

interface Props {
  children: ReactNode;
}

const isGTMLoaded = (): boolean => {
  if (typeof window === 'undefined') return false;

  if (!window.dataLayer) {
    return false;
  }

  const hasGtmEvent = window.dataLayer.some(function (item) {
    return item && item.event === 'gtm.js';
  });

  return hasGtmEvent;
};

export const TrackingProvider = ({ children }: Props): React.JSX.Element => {
  const gtmEvent = useCallback((data: GtmPayload, callback?: () => void) => {
    if (isGTMLoaded()) {
      const payload = callback ? { ...data, eventCallback: callback } : data;
      window.dataLayer?.push(payload);
    } else {
      console.error('GTM dataLayer is not defined and GTM script is not loaded.');
      callback?.(); // Still execute callback if GTM is unavailable
    }
  }, []);

  const trackingContext = useMemo(() => ({ gtmEvent }), [gtmEvent]);

  return <TrackingContext.Provider value={trackingContext}>{children}</TrackingContext.Provider>;
};
